import {bindActionCreators} from 'redux';
import {createStructuredSelector} from 'reselect';
import {realTimePriceQuantityChange} from '~/actions/AnalyticsActions';
import {
  isBlank,
  isLabBlankLoad,
  viewColorCount,
  viewColorsJs
} from '~/selectors/CanvasSelectors';
import {
  anchorColorCount,
  fullColorViews,
  getColorSelections,
  getRealTimePriceQuantity,
  getSelectedProductColorMinimum,
  getSelectedProductMinimum,
  getSelectedProductRealTimeItemPrice,
  getTotalDefaultQuantity
} from '~/selectors/ProductSelectors';
import {
  getRealTimeItemizedPrices,
  getQuantities,
  getTotalQuantity,
  hasColorfulQuote,
  hasFullQuote,
  hasQuantitiesForAllProducts,
  hasTouchedQuantities
} from '~/selectors/QuoteSelectors';
import {getPrintMinimum} from '~/selectors/FundraisingSelectors';

export const selectors = createStructuredSelector({
  colorMinimum: getSelectedProductColorMinimum,
  colorSelections: getColorSelections,
  fullColorViews,
  printMinimum: getPrintMinimum,
  hasColorfulQuote,
  hasFullQuote,
  hasQuantitiesForAllProducts,
  hasTouchedQuantities,
  isBlank,
  isLabBlankLoad,
  itemPrice: getSelectedProductRealTimeItemPrice,
  itemizedPrices: getRealTimeItemizedPrices,
  quantities: getQuantities,
  productMinimum: getSelectedProductMinimum,
  selectedQuantity: getRealTimePriceQuantity,
  totalDefaultQuantity: getTotalDefaultQuantity,
  totalQuantity: getTotalQuantity,
  viewColorCount,
  viewColors: anchorColorCount,
  designColors: viewColorsJs
});

export const actions = dispatch =>
  bindActionCreators(
    {
      onClick: realTimePriceQuantityChange
    },
    dispatch
  );
